import { ChangeStagesEnum } from 'config/environments/shared';

export const getStepByAddress = (pathname: string) => {
  if (pathname.includes('/senha')) {
    return ChangeStagesEnum.VALIDATE;
  }
  if (pathname.includes('/confirmacao')) {
    return ChangeStagesEnum.FORM;
  }
  if (pathname.includes('/informacoes-importantes')) {
    return ChangeStagesEnum.IMPORTANT_INFORMATION;
  }
  if (pathname.includes('/modal-confirmacao')) {
    return ChangeStagesEnum.CONFIRMATION_MODAL;
  }
  if (pathname.includes('/sucesso')) {
    return ChangeStagesEnum.SUCCESS;
  }
  if (pathname.includes('/erro')) {
    return ChangeStagesEnum.ERROR;
  }
};
